import { CameraViewName } from './types';
import { Vector3 } from 'three';
export const Views = {
    [CameraViewName.Top]: {
        offset: new Vector3(0, 0, 1),
        up: new Vector3(0, -1, 0),
    },
    [CameraViewName.Bottom]: {
        offset: new Vector3(0, 0, -1),
        up: new Vector3(0, 1, 0),
    },
    [CameraViewName.Right]: {
        offset: new Vector3(-1, 0, 0),
        up: new Vector3(0, 0, 1),
    },
    [CameraViewName.Left]: {
        offset: new Vector3(1, 0, 0),
        up: new Vector3(0, 0, 1)
    },
    [CameraViewName.Front]: {
        offset: new Vector3(0, 1, 0),
        up: new Vector3(0, 0, 1),
    },
    [CameraViewName.Back]: {
        offset: new Vector3(0, -1, 0),
        up: new Vector3(0, 0, 1),
    },
    [CameraViewName.FrontTopLeft]: {
        offset: new Vector3(1, 1, 1),
        up: new Vector3(-1, -1, 1),
    },
    [CameraViewName.FrontTopRight]: {
        offset: new Vector3(-1, 1, 1),
        up: new Vector3(1, -1, 1),
    },
    [CameraViewName.FrontBottomLeft]: {
        offset: new Vector3(1, 1, -1),
        up: new Vector3(1, 1, 1),
    },
    [CameraViewName.FrontBottomRight]: {
        offset: new Vector3(-1, 1, -1),
        up: new Vector3(-1, 1, 1),
    },
    [CameraViewName.BackTopLeft]: {
        offset: new Vector3(1, -1, 1),
        up: new Vector3(-1, 1, 1),
    },
    [CameraViewName.BackTopRight]: {
        offset: new Vector3(-1, -1, 1),
        up: new Vector3(1, 1, 1),
    },
    [CameraViewName.BackBottomLeft]: {
        offset: new Vector3(1, -1, -1),
        up: new Vector3(1, -1, 1),
    },
    [CameraViewName.BackBottomRight]: {
        offset: new Vector3(-1, -1, -1),
        up: new Vector3(-1, -1, 1),
    },
    [CameraViewName.FrontTop]: {
        offset: new Vector3(0, 1, 1),
        up: new Vector3(0, -1, 1),
    },
    [CameraViewName.FrontBottom]: {
        offset: new Vector3(0, 1, -1),
        up: new Vector3(0, 1, 1),
    },
    [CameraViewName.FrontLeft]: {
        offset: new Vector3(1, 1, 0),
        up: new Vector3(0, 0, 1)
    },
    [CameraViewName.FrontRight]: {
        offset: new Vector3(-1, 1, 0),
        up: new Vector3(0, 0, 1)
    },
    [CameraViewName.BackTop]: {
        offset: new Vector3(0, -1, 1),
        up: new Vector3(0, 1, 1)
    },
    [CameraViewName.BackBottom]: {
        offset: new Vector3(0, -1, -1),
        up: new Vector3(0, -1, 1)
    },
    [CameraViewName.BackLeft]: {
        offset: new Vector3(1, -1, 0),
        up: new Vector3(0, 0, 1)
    },
    [CameraViewName.BackRight]: {
        offset: new Vector3(-1, -1, 0),
        up: new Vector3(0, 0, 1)
    },
    [CameraViewName.TopLeft]: {
        offset: new Vector3(1, 0, 1),
        up: new Vector3(-1, 0, 1),
    },
    [CameraViewName.TopRight]: {
        offset: new Vector3(-1, 0, 1),
        up: new Vector3(1, 0, 1)
    },
    [CameraViewName.BottomLeft]: {
        offset: new Vector3(1, 0, -1),
        up: new Vector3(1, 0, 1)
    },
    [CameraViewName.BottomRight]: {
        offset: new Vector3(-1, 0, -1),
        up: new Vector3(-1, 0, 1)
    }
};
